import appInfoMap from '../isAppInstall/appInfoMap';
import open from '../open/openUrl';
import isIphone from '../isIphone';
import { getMarketUrl } from '../open/base';
import { downloadApk } from '../open/downloadApk';
import { Platform } from 'react-native';
import getDeviceInfoSync from '../getDeviceInfoSync';
import request from '../request';
import clipboard from '../clipboard';
import { stringify } from 'qs';
import onVisibleChange from '../onVisibleChange';
/**
 * opt 传入NewAppLink，或者所有页面参数
 * @param app
 * @param opt
 * @returns
 */
export default async function openMarket(app, opt) {
    const appInfo = appInfoMap[app];
    if (!appInfo) {
        console.error('no app: ' + app);
        return;
    }
    const deviceInfo = getDeviceInfoSync();
    try {
        if (opt && appInfo.setNewAppLink) {
            let _opt = opt;
            // for pageProps
            if (!opt.schema && !opt.content) {
                // 过滤平台参数
                const { 
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                rootTag, 
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                onCreateTimestamp, 
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                startTimestamp, 
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                themeStyle, 
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                title, ...rest } = opt;
                _opt = {
                    from: opt.from,
                    schema: Platform.OS === 'web'
                        ? appInfo.getWebLink
                            ? appInfo.getWebLink(window.location.href, {})
                            : window.location.href
                        : `${appInfo.prefix || app}://krn?${stringify(rest)}`,
                    type: 3,
                };
            }
            _opt.egid = opt.egid || deviceInfo.globalId;
            await appInfo.setNewAppLink(request, clipboard, _opt);
        }
    }
    catch (e) {
        console.error('setNewAppLink error', e, deviceInfo);
    }
    const markets = getMarketUrl(app);
    if (!deviceInfo.isMobile) {
        open(markets.pc || '');
        return;
    }
    if (deviceInfo.platform === 'harmony') {
        open(markets.harmonyMarket);
        return;
    }
    // 小米手机应用商店有问题，过去展示要去搜索，抛包
    if (appInfo?.getApkUrl &&
        Platform.OS === 'web' &&
        (deviceInfo?.model?.startsWith?.('Xiaomi') ||
            deviceInfo?.model?.startsWith?.('unknown'))) {
        //抛包
        await downloadApk(await appInfo.getApkUrl(request, opt?.use32));
        return;
    }
    else if (!isIphone() &&
        (opt?.rootTag || Platform.OS === 'web') &&
        appInfo.getApkUrl) {
        let opened = false;
        let timer = window.setTimeout(async () => {
            if (opened) {
                return;
            }
            // @ts-ignore
            await downloadApk(await appInfo.getApkUrl(request, opt?.use32));
        }, 2000);
        const sub = onVisibleChange((visible) => {
            if (!visible) {
                opened = true;
            }
            clearTimeout(timer);
            sub.remove();
        }, opt?.rootTag ?? 0);
    }
    const isHonor = deviceInfo?.manufacturer
        ?.toLowerCase?.()
        ?.startsWith?.('honor');
    const androidMarket = isHonor ? markets.honorMarket : markets.androidMarket;
    open(isIphone() ? markets.iosMarket : androidMarket);
}
